import './MuiClassNameSetup'
import React from 'react'
import { render } from 'react-dom'
import * as OfflinePluginRuntime from 'offline-plugin/runtime'
import './style.css'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { queryClient } from 'queries/queryClient'
import App from './App'

OfflinePluginRuntime.install()

const renderApp = (rootNodeId = 'root') => {
  const root = document.querySelector(`#${rootNodeId}`)

  if (root) {
    render(
      <React.StrictMode>
        <QueryClientProvider client={queryClient}>
          <App />
          <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
      </React.StrictMode>,
      root,
    )
  }
}

renderApp()
